import React from 'react';
import './styles.css';
import { WarningOutlined } from '@ant-design/icons';

const NotAllowedPage = () => {

  return (
    <div className="not-allowed-page-container">
      <div className="content-wrapper">
        <WarningOutlined className="not-allowed-icon"/>
        <h2>Lo sentimos, no tienes permiso para acceder a este contenido.</h2>
        <h2>Por favor contacta con el encargado de tu establecimiento.</h2>
      </div>
    </div>
  )
}

export default NotAllowedPage;